export default "__VITE_ASSET__d052e7b9__"